import { c as _c } from "react/compiler-runtime";
import { ErrorMessage } from '@newfront-insurance/admin-ui/layout';
import { Button, Flexbox, IconNotAllowed, Text } from '@newfront-insurance/core-ui';
import { useProvider } from '@newfront-insurance/react-provision';
import type { PropsWithChildren, JSX } from 'react';
import { AuthProvider } from '@/client/providers/auth';
const SERVICE_DESK_HREF = 'https://newfront.atlassian.net/servicedesk/customer/portal/1';
export function IncompleteUserErrorProvider(props) {
  const $ = _c(6);
  const {
    children
  } = props;
  const {
    userDetails
  } = useProvider(AuthProvider);
  if (userDetails?.scopes.length === 0 || !userDetails?.uuid) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <IconNotAllowed />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Button onClick={_temp}>Try refreshing the page</Button>;
      t2 = <Text size="large">or</Text>;
      $[1] = t1;
      $[2] = t2;
    } else {
      t1 = $[1];
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ErrorMessage title={`Looks like your dash user isn't completed`} subtitle="Please create a ticket or contact your manager." icon={t0} action={<Flexbox flexDirection="column" justifyContent="center" alignItems="center" gap={8}>{t1}{t2}<Button size="secondary" href={SERVICE_DESK_HREF} target="_blank" style={{
          textAlign: "center"
        }}>Create a ticket</Button></Flexbox>} />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t0;
  if ($[4] !== children) {
    t0 = <>{children}</>;
    $[4] = children;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}
function _temp() {
  window.location.reload();
}